<template>
    <section id="default-page">
        <div class="container full-width">
            <div class="row">
                <div class="search-result-top">
                    <div class="top">
                        <div class="left">
                            <h2>
                                Companies
                            </h2>
                        </div>
                        <div class="right">
                        </div>
                    </div>
                    <div class="bottom">
                    </div>
                </div>
                <div class="container-table">
                    <b-table
                        class="list-table"
                        responsive=""
                        :sort-by.sync="sort_by"
                        :sort-asc.sync="sort_asc"
                        :fields="fields"
                        :items="companies"
                        show-empty
                    >
                        <template v-slot:empty="scope">
                            No companies found
                        </template>
                        <template v-slot:cell(action)="data">
                            <div>
                                <a :href="$laravelRoute('companies.show', data.item.id)" class="link">View</a>
                                <a :href="$laravelRoute('companies.edit', data.item.id)" class="link">Edit</a>
                                <a href="#!" @click.prevent="deleteCompany(data.item)" class="link">Delete</a>
                            </div>
                        </template>
                        <template v-slot:cell(website)="data">
                            <a v-if="data.item.website" :href="data.item.website" class="link">{{data.item.website}}</a>
                        </template>
                        <template v-slot:cell(status)="data">
                            <span v-if="data.item.status_id === 1" class="text-success">Active</span>
                            <span v-if="data.item.status_id === 2" class="text-info">Preview</span>
                            <span v-if="data.item.status_id === 3" class="text-warning">Stock Only</span>
                            <span v-if="data.item.status_id === 4" class="text-danger">Blocked</span>
                        </template>
                        <template v-slot:cell(user_count)="data">
                            <template v-if="data.item.users_count">{{data.item.users_count}}</template>
                        </template>
                    </b-table>
                </div>
                <div class="bottom-table">
                    <b-pagination
                        v-if="total > 0"
                        :total-rows="total"
                        v-model="current_page"
                        :per-page="per_page"
                    ></b-pagination>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import {getExceptionErrorMessage} from '../../util/common'
import axios from "axios";
export default {
    created(){
        this.getCompanies();
    },
    data() {
        return {
            companies: [],
            fields: [
                {label: 'Status', key: 'status', sortable: false},
                {label: 'Name', key: 'name', sortable: false},
                {label: 'Phone', key: 'phone_number', sortable: false},
                {label: 'Users', key: 'user_count', sortable: false},
                {label: 'Website', key: 'website', sortable: false},
                {label: 'Action', key: 'action', sortable: false},
            ],
        }
    },
    computed: {
    },
    methods: {
        async getCompanies(){
            const res = await axios.get(this.$laravelRoute('companies.list'))
            if (res && res.data && res.data.companies) {
                this.companies = res.data.companies
            }
        },
        async deleteCompany(company){
            try {
                await this.$confirm('Are you sure you want to delete ' +company.name+ '?')
            } catch (e) {
                console.log('Delete cancelled')
                return;
            }
            try {
                const res = await axios.delete(this.$laravelRoute('companies.destroy', company.id))
                if (res && res.data && res.data.message) {
                    this.$message({
                        message: res.data.message,
                        type: 'success'
                    });
                    await this.getCompanies();
                }
            } catch (e) {
                let msg = getExceptionErrorMessage(e)
                if (!msg) {
                    msg = 'There was a problem deleting the company.'
                }
                this.$message.error(msg);
            }
        },
    }
}

</script>



// WEBPACK FOOTER //
// resources/js/components/Companies/List.vue